import { ComponentType } from 'react';

import { OffersTabNavbarIcon } from '@ocx/graphql';
import {
  TabBarOffersGiftIcon,
  TabBarOffersPercentIcon,
  TabBarOffersStarIcon,
  TabBarOffersTagIcon,
} from '@ocx/ui-icons';

const offersTabIconMap: Record<OffersTabNavbarIcon, ComponentType> = {
  [OffersTabNavbarIcon.Gift]: TabBarOffersGiftIcon,
  [OffersTabNavbarIcon.Percent]: TabBarOffersPercentIcon,
  [OffersTabNavbarIcon.Star]: TabBarOffersStarIcon,
  [OffersTabNavbarIcon.Tag]: TabBarOffersTagIcon,
};

export const getOffersTabIcon = (icon?: OffersTabNavbarIcon | null): ComponentType => {
  // TabBarOffersPercentIcon this is a default icon
  if (!icon) return TabBarOffersPercentIcon;
  return offersTabIconMap[icon];
};
